import React from 'react';
import Rating from 'react-rating';
import { areEqual } from '../../util';
import './Rating.css';

const StarRating = React.memo(
  ({
    numberOfStars,
    className,
    noNumber,
    numberFirst = false,
    emptySymbol = 'fa fa-star-o',
    fullSymbol = 'fa fa-star',
    rating,
    changeRating=()=> console.log('Please pass changeRating handler'),
    style = {},
    readOnly,
  }) => {
    const decimalSeparatedRating = rating.toFixed(1).replace('.', ',');
    return (

      <span style={style} className={className} title={readOnly ? decimalSeparatedRating : ''}>
        {numberFirst && !noNumber && <div className="rating-number">{decimalSeparatedRating}</div>}
        <Rating
          emptySymbol={emptySymbol}
          fullSymbol={fullSymbol}
          fractions={1}
          stop={numberOfStars}
          initialRating={rating}
          onChange={changeRating}
          readonly={readOnly}
        />
        {!numberFirst && !noNumber && <div className="rating-number">{decimalSeparatedRating}</div>}
      </span>
    );
  },
  areEqual,
);

export default StarRating;
